import React from 'react'
import DashboardCards from './DashboardCards'
import DashboardGraph from './DashboardGraph'
import CertificationGraph from './CertificationGraph'

const Dashboard = () => {
  return (
    <div>
       <DashboardCards/>
       <DashboardGraph/>
       <CertificationGraph/>
    </div>
  )
}

export default Dashboard
